/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { OrderedMap, Map, Record, Set } from 'immutable';
import { List } from 'immutable';
import * as Constellation from 'modules/constellation';
import * as Defaults from './defaults';
import { createSelector } from 'reselect';

export const entities = createSelector(
  Constellation.getters.currentReportOrListItem,
  report => {
    return report
      .get('indicators', List())
      .map(d => d.get('value', null))
      .toSet();
  }
);

export const scores = getterFromKeyPath(['entityScores', 'scores']);
export const sortScore = getterFromKeyPath(['entityScores', 'sort', 'scores']);
export const loading = getterFromKeyPath(['entityScores', 'loading']);
export const modalOpen = getterFromKeyPath(['entityScores', 'modalOpen']);
export const currentQuery = getterFromKeyPath(['entityScores', 'currentQuery']);

export const currentQueryWithEntities = createSelector(
  currentQuery,
  entities,
  (currentQuery, entities) => {
    return currentQuery.set('query', entities);
  }
);

export const scoresByEntity = createSelector(
  scores,
  entities,
  sortScore,
  (scores: OrderedMap<any, any>, entities: Set<string>, sortScore) => {
    return scores
      .filter(current => entities.has(current.get('value')))
      .reduce((acc: Map<any, any>, current, i, arr) => {
        if (!acc.has(current.get('value'))) {
          acc = acc.set(current.get('value'), List());
        }
        return acc.update(current.get('value'), l => l.push(current));
      }, OrderedMap())
      .map(scoreList =>
        scoreList.sortBy(sortScore.get('sortByKey'), sortScore.dir)
      );
  }
);

export const defaultPayload = Map({
  query: '',
  sort: Map(Defaults.sorterValues.searchSorters),
  pageNumber: 0,
  pageSize: 25
});

export const defaultResult = Map({
  empty: true,
  items: List() // PAGE SIZE and stuff? TODO
});



// WEBPACK FOOTER //
// ./src/app/modules/entity-scores/getters.js